import React from 'react';
import {
	AnalysisWrapper,
	FiltersWrapper,
	FlexCenterText,
	TableBody,
	TableCellChart,
	TableCellGroup,
	TableCellMax,
	TableCellMin,
	TableContainer,
	TableHead,
	TableRow,
} from './components/BenchmarkContainer.styles';
import ChartLegend from './components/ChartLegend/ChartLegend';
import CategoryHierarchy from './components/CategoryHierarchy/CategoryHierarchy';
import { SingleFilterWrapper } from 'SpendController/Components/Components.styles';
import MultiSelect from 'SpendController/Components/MultiSelect/MultiSelect';
import { useBenchmarkContext } from '../Contexts/BenchmarkProvider';
import {
	ApLoaderDefault,
	ApLoaderText,
	ApSimpleDropdown,
} from '@alixpartners/ui-components';

function BenchmarkCategoryAnalysis() {
	const {
		breakDownFilters,
		currentBreakDownFilterCategory,
		currentFilterOptionsCategory,
		currentFilterValuesSelectedCategory,
		setcurrentFilterValuesSelectedCategory,
		isLoading,
		handleFilterByChangeCategory,
		categoryAnalysisData,
		onExpand,
		onToggle,
	} = useBenchmarkContext();
	return (
		<div style={{ margin: '20px' }}>
			<FiltersWrapper>
				<ApSimpleDropdown
					label={`Filter By`}
					onChange={e => handleFilterByChangeCategory(e)}
					options={breakDownFilters.filter(
						item => item.value !== 'Vendor_Name'
					)}
					selected={breakDownFilters.find(
						e => e.value === currentBreakDownFilterCategory.value
					)}
				/>
				<SingleFilterWrapper>
					<MultiSelect
						name={`${currentBreakDownFilterCategory.label}`}
						label={`${currentBreakDownFilterCategory.label}`}
						options={currentFilterOptionsCategory}
						selected={currentFilterValuesSelectedCategory}
						onChange={v => {
							setcurrentFilterValuesSelectedCategory(v);
						}}
					/>
				</SingleFilterWrapper>
				{/* <ApButtonMain
                        style={{marginLeft:"50px"}}
                                    title="Apply Filter"
                                    iconName="filter_outlined"
                                    onClick={()=>{
                                        console.log("asdasdasd")
                                        applyVendorFilters()
                                    }}
                                >
                                    Apply
                                </ApButtonMain> */}
			</FiltersWrapper>

			{!isLoading ? (
				categoryAnalysisData.length > 0 ? (
					<AnalysisWrapper isExpanded={true} index="0" isScroll={true}>
						<TableContainer>
							<TableHead>
								<TableRow>
									<TableCellGroup title="Category Name">
										Category Name
									</TableCellGroup>
									<TableCellMin title="Peer Count">Peer Count</TableCellMin>
									<TableCellMin title="Lower end of interquartile range">
										Low End (days)
									</TableCellMin>
									<TableCellChart>
										<ChartLegend />
									</TableCellChart>
									<TableCellMax title="Higher end of interquartile range">
										High End (days)
									</TableCellMax>
								</TableRow>
							</TableHead>
							<TableBody>
								<CategoryHierarchy
									data={categoryAnalysisData}
									showClassifications={false}
									showToggleButton={true}
									onExpand={onExpand}
									onToggle={onToggle}
								/>
							</TableBody>
						</TableContainer>
					</AnalysisWrapper>
				) : (
					<FlexCenterText>No data available</FlexCenterText>
				)
			) : (
				<ApLoaderDefault loaderText={() => <ApLoaderText />} />
			)}
		</div>
	);
}

export default BenchmarkCategoryAnalysis;
